import max from 'lodash/max';
import flatten from 'lodash/flatten';
import cloneDeep from 'lodash/cloneDeep';
import {nanoid} from 'nanoid';
import {constants} from '@neosvoc/nv-platform-core-common';
import choiceIdsRegenerators from './choiceIdsRegenerators';
import rowIdsRegenerators from './rowIdsRegenerators';

export const generateNextPageId = (editor) => `p${(max(toIntegerArray(editor.pages.map((page) => page.id))) || 0) + 1}`;
export const generateNextQuestionId = (editor) => ((max(toIntegerArray(flatten(editor.pages.map((page) =>
    flatten(page.items).map((item) => item.id))))) || 0) + 1).toString();
export const generateNextChoiceId = (choices) => ((max(toIntegerArray(choices.map((row) => row.id))) || 0) + 1).toString();
export const generateNextRowId = (rows) => ((max(toIntegerArray(rows.map((row) => row.id))) || 0) + 1).toString();

export const regenerateIds = (editor) => {
    let newEditor = regeneratePageIds(editor);
    newEditor = regenerateQuestionsIds(newEditor);

    const items = flatten(newEditor.pages.map((page) => flatten(page.items)));
    items.forEach((item) => regenerateRowIds(regenerateChoiceIds(item)));

    return newEditor;
};

export const regeneratePageIds = (editor) => {
    const newEditor = cloneDeep(editor);
    newEditor.pages.forEach((page, index) => page.id = `p${index + 1}`);
    return newEditor;
};

export const regenerateQuestionsIds = (editor) => {
    const newEditor = cloneDeep(editor);
    const items = flatten(newEditor.pages.map((page) => flatten(page.items)));
    items
        .filter((item) => item.type !== constants.EDITOR_TEMPLATES.TEXT_1)
        .forEach((item, index) => item.id = `${index + 1}`);
    return newEditor;
};

export const regenerateQuestionIds = (editor, page) => {
    const newPage = cloneDeep(page);
    const items = flatten(newPage.items);
    items.forEach((item, index) => item.id = generateNextQuestionId(editor));
    return newPage;
};

export const regenerateRowIds = (item) => {
    return rowIdsRegenerators[item.type](item);
};

export const regenerateChoiceIds = (item) => {
    return choiceIdsRegenerators[item.type](item);
};

export const toIntegerArray = (items) => items.map((item) => {
    const value = +item;
    return Number.isNaN(value) ? toNumber(item) : value;
});

export const toNumber = (item) => {
    if (item === undefined) {
        return 0;
    }
    const matches = item.match(/\d+$/);
    return matches ? +matches[0] : 0;
};

export const generateApiKey = () => nanoid();

export const generateExclusiveChoiceId = (max) => (max? max + 1: 1);
